import { createApp } from "vue";

import I18n from "../plugins/i18n";
import ShippingCalculatorDrawer from "../components/shipping/ShippingCalculatorDrawer.vue";

window.setupShippingCalculatorDrawer = quantity => {
  const nodes = document.querySelectorAll(".shipping-calculator-drawer-app");

  if (!nodes.length) return;

  nodes.forEach(node => {
    if (node.hasAttribute("data-v-app")) return;

    const props = JSON.parse(node.dataset.props);
    props.standardQuantity = quantity;

    const translations = JSON.parse(node.dataset.translations);

    const app = createApp(ShippingCalculatorDrawer, props);

    app.use(I18n, translations);
    app.mount(node);

    window.vueApps.push(app);
  });
};
